<template>
  <article>
    <div class="container-fixed">
      <p class="offset-top-2 offset-bottom-2" v-html="$t('rechargingtransactions.rechargingInfotext')"></p>
    </div>
    <div id="RECHARGE_TRANSACTIONS" class="container-fixed offset-bottom-4">
      <VFilter @update="onFilterUpdate" />
    </div>
    <div v-if="validRows" class="container-fluid grayed-offset">
      <div class="container-fixed">
        <VList :rows="rows" />
      </div>
    </div>
    <div v-if="hasShowCCTransactionView" class="container-fixed">
      <VDetails @update="onDetailsUpdate" />
    </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { dateTimeInputFormat, dateUrlFormat } from '@/utils/date';
import { RECHARGE_TRANSACTIONS_OVERVIEW_DETAILS } from '@route-types';
import TitleMixin from '@/mixins/title';
import VFilter from './Filter';
import VList from './List';
import VDetails from './Details';

export default {
  name: 'RechargeTransactions',

  components: {
    VFilter,
    VList,
    VDetails,
  },

  mixins: [TitleMixin],

  data() {
    return {
      rows: null,
    };
  },

  computed: {
    ...mapGetters('system', ['hasShowCCTransactionView']),

    validRows() {
      return this.rows && this.rows.length;
    },
  },

  methods: {
    onFilterUpdate(response) {
      this.rows = response;
    },

    onDetailsUpdate(response) {
      if (!this.$route.params.from || !this.$route.params.to) {
        // if list is not loaded (e.g. deeplink from contractSearch)
        const from = format(parse(response.transaction.start, dateTimeInputFormat, new Date()), dateUrlFormat);
        const to = from;
        this.$router.replace({
          name: RECHARGE_TRANSACTIONS_OVERVIEW_DETAILS,
          params: { ...this.$route.params, from, to, disableScrolling: null },
        });
      }
    },
  },
};
</script>
